import update from 'immutability-helper'
import _ from 'lodash'
import moment from 'moment'
import {
    ORDER_LIST_FETCHED,
    ORDER_MODEL_LOADED,
    ORDER_MODEL_UPDATED_BY_FORM,
    ORDER_LINE_ADDED_TO_MODEL,
    ORDER_LINE_UPDATED_OF_UNSAVED_MODEL,
    ORDER_LINE_DELETED_OF_MODEL,
    ORDER_STATUS_UPDATED,
    UPDATE_ORDER_HOLD_REASON,
    ORDER_NOTE_ADDED,
    ORDER_NOTE_DELETE
} from '../actions/types'

export default function order(state = {
    list: {
        on_page: 1,
        per_page: 15,
        total_count: 0,
        data: []
    },
    model: {
        
    },
    pristine: {
        
    },
    dirty: false
}, action = {}) {
    switch(action.type) {
        case ORDER_LIST_FETCHED:
            return update(state, {
                list: {$set: action.payload}
            });

        case ORDER_MODEL_LOADED:
            return update(state, {
                model: {$set: action.payload},
                pristine: {$set: action.payload},
                dirty: {$set: false}
            });

        case ORDER_MODEL_UPDATED_BY_FORM:
            const {field, value} = action.payload;
            const updatedModel = update(state.model, {
                [field]: {$set: value}
            });
            if (_.isEqual(updatedModel, state.pristine)) {
                return update(state, {
                    model: {$set: updatedModel},
                    dirty: {$set: false}
                })
            } else {
                return update(state, {
                    model: {$set: updatedModel},
                    dirty: {$set: true}
                })
            }

        case ORDER_LINE_ADDED_TO_MODEL:
            return update(state, {
                model: {
                    lines_view: {$push: [action.payload]}
                },
                dirty: {$set: true}
            });

        case ORDER_LINE_UPDATED_OF_UNSAVED_MODEL:
            const unsavedLineIndexUpdate = _.findIndex(state.model.lines_view, l => {
                return l.id === action.payload.lineId 
            });
            if (unsavedLineIndexUpdate > -1) {
                return update(state, {
                    model: {
                        lines_view: {
                            [unsavedLineIndexUpdate]: {
                                [action.payload.field]: {$set: action.payload.value}
                            }
                        }
                    },
                    dirty: {$set: true}
                })
            }
            return state;

        case ORDER_LINE_DELETED_OF_MODEL:
            const linesAfterDeleted = state.model.lines_view.filter(item => {
                return item.id !== action.payload;
            });
            return update(state, {
                model: {
                    lines_view: {$set: linesAfterDeleted}
                }
            });

        case ORDER_STATUS_UPDATED:
            const newStatus = action.payload;
            const oldStatus = state.model.status;
            let issueDate = null;
            if (newStatus === 'Finalized' && oldStatus === 'Open') {
                issueDate = moment().format('YYYY-MM-DD').toString();
            }
            if (newStatus === 'Open' && oldStatus === 'Finalized') {
                issueDate = null
            }
            return update(state, {
                model: {
                    status: {$set: action.payload},
                    issued_at: {$set: issueDate}
                },
                pristine: {
                    status: {$set: action.payload},
                    issued_at: {$set: issueDate}
                },
                dirty: {$set: false}
            });

        case UPDATE_ORDER_HOLD_REASON: 
            return update(state, {
                model: {
                    hold_reason: {$set: action.payload}
                },
                pristine: {
                    hold_reason: {$set: action.payload}
                }
            });

        /*
    ORDER_NOTE_ADDED,
    ORDER_NOTE_DELETE
        */
       case ORDER_NOTE_ADDED:
            return update(state, {
                model: {
                    comments: {$push: [action.payload]}
                },
                pristine: {
                    comments: {$push: [action.payload]}
                }
            });

        case ORDER_NOTE_DELETE:
            return update(state, {
                model: {
                    comments: {
                        [action.payload.index]: {$set: action.payload.data}
                    }
                },
                pristine: {
                    comments: {
                        [action.payload.index]: {$set: action.payload.data}
                    }
                }
            })

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/orders.js